import { Box, Stack, Typography } from "@mui/material";

/* eslint-disable arrow-body-style */
const NormalPeople = () => {
    return (
        <>
            <Stack direction={"column"} gap={1.5}>

                <Typography
                    sx={{
                        fontWeight: 700,
                        fontSize: 17,
                        mb:2,
                        color:"red"
                    }}
                >
                    زائر گرامی لطفا در اسرع وقت ثبت نام خود را نهایی کرده و به پیام های موجود در سامانه توجه فرمائید.
                </Typography>

                {/* <Typography
                    sx={{
                        fontWeight: 700,
                        fontSize: 20
                    }}
                >
                    دستورالعمل اجرائی ثبت نام و اعزام
                </Typography>
                <Typography
                    sx={{
                        fontWeight: 700,
                        fontSize: 17
                    }}
                >
                    فرهیخته گرامی
                </Typography>

                <Typography
                    sx={{
                        fontSize: 15
                    }}
                >
                    با سلام و آرزوی توفیق الهی
                </Typography>

                <Typography
                    sx={{
                        lineHeight: 2,
                        fontSize: 15
                    }}
                >
                    در راستای عمل به منویات مقام معظم رهبری مبنی بر تقویت مبانی فکری، اعتقادی و معنویت در جامعه اسلامی اعزام کاروان های دانشگاهی به عمره مفرده با اختصاص سهمیه ویژه و بدون نیاز به فیش ودیعه عمره صورت می گیرد. با توجه به پذیرفته شدن شما از میان خیل مشتاقان این سفر(بالغ بر 120هزار نفر متقاضی) ضمن تبریک انتخاب شما در قرعه كشي عمره 1404، خواهشمند است به دقت مطالب و مراحل زير را مطالعه نموده ، و در صورت داشتن شرایط ذکر شده برای اعزام ، نسبت به نهایی کردن ثبت نام خود اقدام نمائید.
                </Typography>

                <Typography
                    sx={{
                        lineHeight: 2,
                        fontSize: 15
                    }}
                >
                    فرصت استفاده از سهمیه عمره دانشگاهیان برای هر شخص فقط یکبار می باشد، افرادی که قبلا(دانشجو یا استاد) با کاروان دانشگاهی اعزام شده اند؛ امکان اعزام مجدد را نخواهند داشت.
                </Typography>

                <Typography
                    sx={{
                        lineHeight: 2,
                        fontSize: 15
                    }}
                    >
                    ابتدا وضعیت اولویت تشرف را ملاحظه نموده(اصلی/ذخیره) سپس نسبت به تکمیل مراحل اقدام نمائید.
                </Typography>

                <Typography
                    sx={{
                        lineHeight: 2,
                        fontSize: 15
                    }}
                    color={"error"}
                >
                    تذکر- اعزام افراد ذخیره بر اساس اولویت تحویل مدارک و مشروط به انصراف افراد اصلی می باشد.
                </Typography>

                <Typography
                    sx={{
                        lineHeight: 2,
                        fontSize: 15
                    }}
                >
                    پذیرفته شدگان اصلی و ذخیره می بایست پس از نهایی کردن ثبت نام جهت دریافت گذرنامه و گواهی اشتغال به تحصیل/تدریس اقدام  نمایند.
                </Typography>

                <Typography
                    sx={{
                        fontSize: 17,
                        fontWeight: 700
                    }}
                >
                    گذرنامه
                </Typography>

                <Box
                    sx={{
                        pl: 1.5
                    }}
                >

                    <Typography
                        sx={{
                            lineHeight: 2,
                            fontSize: 15
                        }}
                    >
                        جهت سفر عمره داشتن گذرنامه بین المللی با اعتبار حداقل 6ماه (تا پایان خرداد1405) ضروری می باشد.
                    </Typography>
                    <Typography
                        sx={{
                            lineHeight: 2,
                            fontSize: 15
                        }}
                    >
                        با گذرنامه زیارتی (حتی در صورت داشتن اعتبار) امکان سفر عمره وجود ندارد.
                        <br />
                        دانشجویان پسر مشمول قبل از اقدام جهت دریافت گذرنامه می بایست فرم های مربوط به مجوز خروج از کشور در سامانه را بارگذاری نمایند تا از طریق تفاهم نامه ستاد عمره و عتبات دانشگاهیان با سازمان وظیفه عمومی، بدون نیاز به وثیقه ،مجوز خروج ایشان صادر گردد.
                        <br />
                        در قسمت مربوط به بارگذاری مدارک؛ عکس پرسنلی مشابه عکس گذرنامه خود را بارگذاری نمائید. برای دریافت فایل عکس گذرنامه می توانید با مراجعه به سایت سخا(<a href="https://sakha.epolice.ir" target="_blank" rel="noreferrer">https://sakha.epolice.ir</a>) و یا از طریق برنامه پلیس من؛ عکس خود را دریافت و سپس در سامانه بارگذاری نمائید.
                    </Typography>
                </Box>

                <Typography
                    sx={{
                        fontSize: 17,
                        fontWeight: 700
                    }}
                >
                    گواهی اشتغال به تحصیل/تدریس:
                </Typography>

                <Typography
                    sx={{
                        lineHeight: 2,
                        fontSize: 15,
                    }}
                >
                    ارائه گواهی اشتغال به تحصیل برای دانشجویان و گواهی اشتغال به تدریس یا حکم کارگزینی برای اساتید محترم ضروری بوده و این گواهی می بایست دارای مهر دانشگاه باشد.
                </Typography>

                <Typography
                    sx={{
                        lineHeight: 2,
                        fontSize: 15,
                    }}
                >

                    توجه: درصورتیکه همسر یا فرزند متقاضی؛ دانشگاهی باشد، ارائه مدارک مرتبط(گواهی اشتغال به تحصیل/تدریس) ضروری می باشد.

                </Typography>

                <Typography
                    sx={{
                        fontSize: 17,
                        fontWeight: 700
                    }}
                >
                    هزینه سفر
                </Typography>

                <Typography
                    sx={{
                        lineHeight: 2,
                        fontSize: 15
                    }}
                >
                    هزینه سفر عمره دانشگاهیان برای هر نفر حدود 65 میلیون تومان می باشد.
                </Typography>

                <Typography
                    sx={{
                        lineHeight: 2,
                        fontSize: 15
                    }}
                >
                    بنا بر اعلام سازمان حج و زیارت؛ هزینه پرداختی گروه سنی  2تا12 سال معادل  90درصد هزینه بزرگسال، و زیر 2سال 15 درصد هزینه بزرگسال می باشد. ضمناً منظور از بزرگسال سن بالای 12 سال می باشد.
                    <br />
                    توجه: گروه سنی از زمان روز پرواز، محاسبه می گردد.
                </Typography>

                <Typography
                    sx={{
                        lineHeight: 2,
                        fontSize: 15
                    }}
                >
                    در این دوره بر اساس هماهنگی های صورت گرفته با مسئولان محترم مراکز آموزش عالی، مکاتبات و جلساتی جهت دریافت وام عمره انجام شده که هنوز نهایی نگردیده و  در صورت تامین اعتبار اطلاع رسانی می گردد.
                    <br />
                    لطفا توجه فرمائید با توجه به زمان کوتاه تا شروع اعزام ها؛ ضروری است هزینه سفر به طور کامل توسط شخص پرداخت گردیده و درصورت نهایی شدن توافق های مربوط به وام؛ پس از بازگشت از سفر از تسهیلات استفاده گردد.
                </Typography>

                <Typography
                    sx={{
                        fontSize: 17,
                        fontWeight: 700
                    }}
                >
                    زمان اعزام:
                </Typography>

                <Typography
                    sx={{
                        lineHeight: 2,
                        fontSize: 15
                    }}
                >
                    اعزام کاروان های دانشگاهیان از 25 آبان لغایت 27 آدر خواهد بود. زمان تقریبی گروه های اعزامی:
                    <br />
                    دختران مجرد دانشجو: 25 آبان لغایت 7 آذر
                    <br />
                    متاهلین و اساتید: 25 آبان لغایت 15 آذر
                    <br />
                    پسران مجرد دانشجو: 16 آذر لغایت 27 آذر
                    <br />
                </Typography>

                <Typography
                    sx={{
                        lineHeight: 2,
                        fontSize: 15
                    }}
                >
                    توجه: امکان تغییر در برنامه پروازی اعلام شده وجود دارد که در صورت جابه جایی اطلاع رسانی خواهد شد.
                </Typography>

                <Typography
                    sx={{
                        lineHeight: 2,
                        fontSize: 15
                    }}
                >
                    درصورتیکه شرایط فوق برای اعزام را نداشته و یا تمایل به اعزام ندارید لطفا از لینک انصراف برای ثبت انصراف خود اقدام نموده تا افراد ذخیره جایگزین گردند .
                </Typography>

                <Typography
                    sx={{
                        lineHeight: 2,
                        fontSize: 15
                    }}
                >
                    تذکر- لازم به ذكر است عدم نهايي كردن ثبت نام، عمل به زمانبندی ها و تحويل به موقع مدارك در مهلت اعلام شده ، به منزله انصراف شخص از اعزام بوده و افراد ذخيره جايگزين خواهند شد .
                </Typography> */}


            </Stack>
        </>
    );
}

export default NormalPeople;